import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'

export const columnsServiceXS = [
    {
        dataField: 'id',
        text: 'Detalle Servicios',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Nombre Servicio:' value={row.services.name} />
                    <TableRowField label='Descuento:' value={`${row.discount} %`} />
                    <TableRowField label='Precio (S/):' value={formatHelper.toMoney(row.price)} />
                </div>
            )
        }
    }
]
export const columnsServiceSM = [
    {
        dataField: 'Service',
        text: 'Nombre Servicio',
        formatter: (cell, row) => {
            return (
                <span>{cell.name}</span>
            )
        }
    },
    {
        dataField: 'discount',
        text: 'Descuento',
        formatter: (cell, row) => {
            return (
                <span>{`${cell} %`}</span>
            )
        }
    },
    {
        dataField: 'price',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        }
    }
];

export const columnsService = [
    {
        dataField: 'Service',
        text: 'Nombre Servicio',
        formatter: (cell, row) => {
            return (
                <span>{cell.name}</span>
            )
        }
    },
    {
        dataField: 'discount',
        text: 'Descuento',
        formatter: (cell, row) => {
            return (
                <span>{`${cell} %`}</span>
            )
        }
    },
    {
        dataField: 'price',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        }
    }
];

export const columnsProductXS = [
    {
        dataField: 'id',
        text: 'Detalle Productos',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Nombre Producto:' value={row.Product.name} />
                    <TableRowField label='Descuento:' value={`${row.discount} %`} />
                    <TableRowField label='Precio (S/):' value={formatHelper.toMoney(row.price)} />
                </div>
            )
        }
    }
]
export const columnsProductSM = [
    {
        dataField: 'Product',
        text: 'Nombre Producto',
        formatter: (cell, row) => {
            return (
                <span>{cell.name}</span>
            )
        }
    },
    {
        dataField: 'discount',
        text: 'Descuento',
        formatter: (cell, row) => {
            return (
                <span>{`${cell} %`}</span>
            )
        }
    },
    {
        dataField: 'price',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        }
    }
];

export const columnsProduct = [
    {
        dataField: 'Product',
        text: 'Nombre Producto',
        formatter: (cell, row) => {
            return (
                <span>{cell.name}</span>
            )
        }
    },
    {
        dataField: 'discount',
        text: 'Descuento',
        formatter: (cell, row) => {
            return (
                <span>{`${cell} %`}</span>
            )
        }
    },
    {
        dataField: 'price',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        }
    }
];



// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferDetail/_columns.js